import { lockScroll, unlockScroll } from '@theme/utilities';

class TmStories extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-tm-dialog]');
    this.video = this.querySelector('[data-tm-video]');
    this.closeButton = this.querySelector('[data-tm-close]');
    this.titleElement = this.querySelector('[data-tm-title]');
    if (!this.dialog || !this.video) return;

    this.trigger = null;
    this.isOpen = false;
    this.savedScrollTop = 0;

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-tm-trigger]');
      if (trigger && this.contains(trigger)) this.open(trigger);
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.dialog.close());
    }

    this.video.addEventListener('ended', () => this.dialog.close());

    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.dialog.close();
    });

    // Some browsers don't dispatch the dialog's close event, so the open
    // attribute is watched instead: it covers every close path, Esc included.
    this.observer = new MutationObserver(() => {
      if (!this.dialog.open) this.reset();
    });
    this.observer.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.isOpen) this.reset();
  }

  open(trigger) {
    const source = trigger.dataset.videoSrc;
    if (!source || this.isOpen) return;

    this.trigger = trigger;
    this.video.setAttribute('src', source);
    if (trigger.dataset.poster) this.video.setAttribute('poster', trigger.dataset.poster);
    if (trigger.dataset.title) this.dialog.setAttribute('aria-label', trigger.dataset.title);
    if (this.titleElement) {
      this.titleElement.textContent = trigger.dataset.title || '';
      this.titleElement.hidden = !trigger.dataset.title;
    }
    this.video.load();

    this.scroller = document.querySelector('.page-wrapper');
    this.savedScrollTop = this.scroller ? this.scroller.scrollTop : window.scrollY;

    this.isOpen = true;
    lockScroll(this);
    this.dialog.showModal();
    if (this.closeButton) this.closeButton.focus();

    const played = this.video.play();
    if (played) {
      played.catch(() => {
        this.video.muted = true;
        this.video.play().catch(() => {});
      });
    }
  }

  reset() {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.video.pause();
    this.video.currentTime = 0;
    this.video.removeAttribute('src');
    this.video.removeAttribute('poster');
    this.video.load();
    this.video.muted = false;

    unlockScroll(this);

    if (this.scroller) {
      this.scroller.scrollTo({ top: this.savedScrollTop, behavior: 'instant' });
    } else {
      window.scrollTo(0, this.savedScrollTop);
    }

    if (this.trigger) {
      this.trigger.focus();
      this.trigger = null;
    }
  }
}

if (!customElements.get('tm-stories')) customElements.define('tm-stories', TmStories);
